import React, { useCallback, useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import api from "../../services/api";
import downloadFile from "../../utils/downloadFile";
import GenericUpper from "../../components/generic-upper";
import { Container, Row, Col } from "react-grid-system";
import TableWithLabelBlackV2 from '../../components/TableWithLabelBlack/indexV2';
import HomologButtonHistory from "../../components/historico/homologButtonHistory";
import Input from "../../components/input/input_v2";
import Button from "../../components/button/button_v2";
import { theme } from "../../styles/theme";
import { H5, TaglineP } from "../../styles/stylesTypography";
import { Loading } from "../../components/loading";
import { store } from "react-notifications-component";
import PaginatorV2 from "../../components/paginator/indexV2";
import status0 from "../../assets/icons/icon-status-nao-enviado.png";
import status2 from "../../assets/icons/icon-status-pending.png";
import status3 from "../../assets/icons/icon-status-enviado.svg";
import status4 from "../../assets/icons/icon-status-reload.png";
import Modal from "../../components/modal/modalGeneric";
import iconCopy from "../../assets/icons/icons8-copiar-32-branco.png";
import * as S from "./styles";

import identifyErrorMenssage from "../../services/identifyErrorMenssage";
const FILTER_FIELD_MAP = {
  numero: "numero",
  protocolo: "protocolo",
  produtor: "produtor",
  propriedade: "propriedade",
  data_emissao: "data_emissao",
  cultura: "cultura",
  produtos: "produtos",
  status: "status",
};
const API_HOMOLOGATION_UFS = ["MT", "SC", "ES", "GO", "DF"];

const normalizeFilterValue = (value) => String(value ?? "").trim();
const isEmptyMode = (mode) => mode === "isEmpty" || mode === "isNotEmpty";

const getTituloErroSisdevMT = (homologacaoErro) => {
  if (!homologacaoErro) return null;
  if (/agr[oô]nomo/i.test(homologacaoErro)) return "Agrônomo não cadastrado no SISDEV";
  if (/falha de comunica[cç][aã]o/i.test(homologacaoErro)) return "Erro de comunicação com SISDEV";
  if (/produtor/i.test(homologacaoErro) && /n[aã]o (est[aá] )?cadastrad/i.test(homologacaoErro)) return "Produtor não cadastrado no SISDEV";
  return "Erro ao homologar no SISDEV";
};

const mapMatchModeToApi = (matchMode) => {
  // Mantemos o matchMode original para refletir exatamente o que foi selecionado no filtro.
  return matchMode;
};

const buildConstraint = (matchMode, value) => {
  const normalizedValue = normalizeFilterValue(value);
  if (!isEmptyMode(matchMode) && !normalizedValue) return null;
  return {
    matchMode: mapMatchModeToApi(matchMode),
    value: normalizedValue,
  };
};

const buildApiFiltersPayload = (columnFilters = {}) => {
  return Object.entries(columnFilters).reduce((acc, [columnKey, state]) => {
    const apiField = FILTER_FIELD_MAP[columnKey];
    if (!apiField || !state) return acc;

    if (columnKey === "status") {
      const selectedValues = Array.isArray(state.selectedValues)
        ? state.selectedValues.map((value) => normalizeFilterValue(value)).filter(Boolean)
        : [];
      if (selectedValues.length === 0) return acc;

      acc[apiField] = {
        operator: selectedValues.length > 1 ? "or" : "and",
        constraints: selectedValues.map((value) => ({
          matchMode: "contains",
          value,
        })),
      };
      return acc;
    }

    const constraints = [];
    const sharedValueForEmptyMode = isEmptyMode(state.mode)
      ? (state.secondaryValue ?? state.value)
      : state.value;
    const primaryConstraint = buildConstraint(state.mode, sharedValueForEmptyMode);
    if (primaryConstraint) constraints.push(primaryConstraint);

    const secondaryConstraint = buildConstraint(state.secondaryMode, state.secondaryValue);
    if (secondaryConstraint) constraints.push(secondaryConstraint);

    if (constraints.length === 0) return acc;

    acc[apiField] = {
      operator: state.combine === "or" ? "or" : "and",
      constraints,
    };
    return acc;
  }, {});
};

const getStatusSystemByUf = (estado) => {
  const normalized = String(estado || "").toUpperCase();
  if (normalized === "GO") return "SIDAGO";
  if (normalized === "DF") return "SIAGRO DF";
  if (normalized === "MT" || normalized === "COMPLEMENTAR") return "SISDEV";
  if (normalized === "SC") return "SIGEN";
  if (normalized === "ES") return "IDAF";
  return "HOMOLOGAÇÃO";
};

const getStatusFilterOptionsByUf = (estado) => {
  const normalized = String(estado || "").toUpperCase();
  const systemName = getStatusSystemByUf(normalized);
  const commonOptions = [
    {
      label: `Enviado para ${systemName}`,
      value: "1",
      color: `${theme.colors.green.Folha}`,
      backgroundColor: "#2FBB6914",
      padding: "5px 8px",
      icon: status3,
    },
    {
      label: `Enviando para ${systemName}`,
      value: "2",
      color: `${theme.colors.yellow.Gema}`,
      backgroundColor: "#F8C84B1F",
      padding: "5px 8px",
      icon: status2,
    },
    {
      label: `Não enviado para ${systemName}`,
      value: "0",
      color: `${theme.colors.red.Tostado}`,
      backgroundColor: "#FF525214",
      padding: "5px 8px",
      icon: status0,
    },
  ];

  if (normalized === "GO" || normalized === "DF") {
    return [
      commonOptions[0],
      {
        label: "NF Pendente",
        value: "3",
        color: "#ff8d14",
        backgroundColor: "#F89E4B14",
        padding: "5px 8px",
        icon: status4,
      },
      commonOptions[1],
      commonOptions[2],
    ];
  }

  if (normalized === "MT") {
    return [
      commonOptions[0],
      commonOptions[1],
      {
        label: "Agrônomo não cadastrado no SISDEV",
        value: "agronomo_nao_cadastrado_sisdev",
        color: "#d9261d",
        backgroundColor: "#FF525214",
        padding: "5px 8px",
        icon: status0,
      },
      {
        label: "Produtor não cadastrado no SISDEV",
        value: "produtor_nao_cadastrado_sisdev",
        color: "#d9261d",
        backgroundColor: "#FF525214",
        padding: "5px 8px",
        icon: status0,
      },
      {
        label: "Erro de comunicação com SISDEV",
        value: "erro_comunicacao_sisdev",
        color: "#d9261d",
        backgroundColor: "#FF525214",
        padding: "5px 8px",
        icon: status0,
      },
      {
        label: "Erro ao homologar no SISDEV",
        value: "4",
        color: "#d9261d",
        backgroundColor: "#FF525214",
        padding: "5px 8px",
        icon: status0,
      },
      commonOptions[2],
    ];
  }

  return commonOptions;
};

const getStatusLabelForFilter = (row, estado) => {
  const normalized = String(estado || "").toUpperCase();
  const homologado = Number(row?.homologado);
  const statusEnvio = Number(row?.status_homologacao);
  const hasHomologacaoErro = !!row?.homologacao_erro;
  const systemName = getStatusSystemByUf(estado);

  if (normalized === "MT" && hasHomologacaoErro && (statusEnvio === 4 || homologado === 0)) {
    return getTituloErroSisdevMT(row?.homologacao_erro);
  }
  if (homologado === 1) return `Enviado para ${systemName}`;
  if (homologado === 2) return `Enviando para ${systemName}`;
  if (homologado === 3) return "NF PENDENTE";
  if (statusEnvio === 4 || homologado === 0) return `Não enviado para ${systemName}`;
  return "";
};

const parseJsonValue = (value) => {
  if (typeof value !== "string") return value;

  try {
    return JSON.parse(value);
  } catch (_) {
    return value;
  }
};

const getRequestPayloadFromRow = (row) => {
  const payloads = row?.agro_prescriptions_payloads;
  if (!Array.isArray(payloads) || payloads.length === 0) return null;

  const firstPayload = payloads[0];
  return firstPayload?.payload != null
    ? parseJsonValue(firstPayload.payload)
    : parseJsonValue(firstPayload);
};

const getInvoiceNumberLabel = (row) => {
  const invoices = row?.agro_prescription_invoices;
  if (!Array.isArray(invoices) || invoices.length === 0) return "-";

  const values = invoices
    .map((invoice) => String(invoice?.nf ?? "").trim())
    .filter(Boolean);

  return values.length > 0 ? values.join(", ") : "-";
};

// Tamanho da pagina usado no carregamento inicial e ao resetar a paginacao.
// Depois disso quem manda e o PaginatorV2, que pode trocar o limite.
const PAGE_SIZE = 30;

const ExportarDefesasDetails = (props) => {
  const { match, history } = props;
  const { uf } = match.params;
  const ufHomolog = uf === "COMPLEMENTAR" ? "MT" : uf;
  const [receitas, setReceitas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [exporting, setExporting] = useState(false);
  const [limit, setLimit] = useState(PAGE_SIZE);
  const [offset, setOffset] = useState(0);
  const [total, setTotal] = useState(0);

  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");
  const [columnFilters, setColumnFilters] = useState({});
  const [visibleRowsCount, setVisibleRowsCount] = useState(0);
  const [tableLoading, setTableLoading] = useState(false);
  const [showPayloadModal, setShowPayloadModal] = useState(false);
  const [selectedPayload, setSelectedPayload] = useState(null);
  const lastFilterPayloadKeyRef = useRef("");
  const inFlightRequestsRef = useRef(0);

  const shouldShowPayloadColumn = API_HOMOLOGATION_UFS.includes(uf);
  const statusFilterOptions = getStatusFilterOptionsByUf(ufHomolog);

  const fetchReceitas = async (
    currentLimit = limit,
    currentOffset = offset,
    options = {},
  ) => {
    const { showLoader = true } = options;
    if (showLoader) setLoading(true);
    inFlightRequestsRef.current += 1;
    setTableLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("@userinfo"));
      const subsidiaryId = user?.agro_subsidiary_id;

      if (subsidiaryId && uf) {
        const response = await api.post(
          `/relatorios/homologados/${subsidiaryId}/${uf}?limit=${currentLimit}&offset=${currentOffset}`,
          {
            data_inicio: dataInicio || null,
            data_fim: dataFim || null,
            filters: buildApiFiltersPayload(columnFilters),
          }
        );
        const data = response?.data?.data || [];
        const totalCount = response?.data?.total || 0;
        // Ensure data is an array
        const normalizedData = Array.isArray(data) ? data : [];
        setReceitas(normalizedData);
        setVisibleRowsCount(normalizedData.length);
        setTotal(totalCount);
      }
    } catch (error) {
      console.error("Erro ao buscar receitas", error);
    } finally {
      inFlightRequestsRef.current = Math.max(0, inFlightRequestsRef.current - 1);
      if (inFlightRequestsRef.current === 0) {
        setTableLoading(false);
      }
      if (showLoader) setLoading(false);
    }
  };

  // PaginatorV2 chama onChange(perPage, offset) - offset, nao numero de pagina.
  // Ele dispara onChange tambem ao montar (pagina 1), por isso o guard: sem ele
  // a tela faria duas buscas identicas no carregamento inicial.
  const handlePaginatorChange = (newLimit, newOffset) => {
    if (newLimit === limit && newOffset === offset) return;
    setLimit(newLimit);
    setOffset(newOffset);
    fetchReceitas(newLimit, newOffset, { showLoader: true });
  };

  // Qualquer mudanca de filtro invalida a pagina atual: o total muda, entao
  // continuar na pagina 8 de um resultado que agora tem 2 paginas mostraria uma
  // lista vazia. Volta para a primeira pagina.
  const resetPaginacaoEBuscar = (options = {}) => {
    setOffset(0);
    fetchReceitas(limit, 0, options);
  };

  const handleColumnFiltersChange = useCallback((nextFilters) => {
    setColumnFilters((previousFilters) => {
      const previousKey = JSON.stringify(previousFilters ?? {});
      const nextKey = JSON.stringify(nextFilters ?? {});
      return previousKey === nextKey ? previousFilters : (nextFilters ?? {});
    });
  }, []);

  useEffect(() => {
    setOffset(0);
    fetchReceitas(limit, 0, { showLoader: true });
  }, [uf]);

  useEffect(() => {
    if (uf === "COMPLEMENTAR") return undefined;

    const filtersPayload = buildApiFiltersPayload(columnFilters);
    const payloadKey = JSON.stringify(filtersPayload);
    const previousPayloadKey = lastFilterPayloadKeyRef.current;
    if (payloadKey === previousPayloadKey) return undefined;

    const hasActiveFiltersNow = Object.keys(filtersPayload).length > 0;
    const hadActiveFiltersBefore = previousPayloadKey !== "" && previousPayloadKey !== "{}";
    lastFilterPayloadKeyRef.current = payloadKey;
    if (!hasActiveFiltersNow && !hadActiveFiltersBefore) return undefined;

    const timer = setTimeout(() => {
      setLimit(PAGE_SIZE);
      setOffset(0);
      fetchReceitas(PAGE_SIZE, 0, { showLoader: false });
    }, 2000);

    return () => clearTimeout(timer);
  }, [columnFilters]);

  const handleExportarArquivo = async () => {
    setExporting(true);
    try {
      const user = JSON.parse(localStorage.getItem("@userinfo"));
      const subsidiaryId = user?.agro_subsidiary_id;

      if (subsidiaryId && uf) {
        const params = new URLSearchParams();
        if (dataInicio) params.append("data_inicio", dataInicio);
        if (dataFim) params.append("data_fim", dataFim);
        const queryString = params.toString();

        const response = await api.get(
          `/relatorios/exportar/homologados/${subsidiaryId}/${uf}${queryString ? `?${queryString}` : ""}`
        );

        if (response?.data?.data) {
          await downloadFile(response.data.data, `homologados-${uf}.xlsx`);
        }
      }
    } catch (error) {
      console.error("Erro ao exportar arquivo", error);
    } finally {
      setExporting(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const day = date.getUTCDate().toString().padStart(2, "0");
    const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  };

  const handleOpenPayloadModal = (row) => {
    const payload = getRequestPayloadFromRow(row);
    setSelectedPayload(payload);
    setShowPayloadModal(true);
  };

  const copyPayloadJson = async () => {
    if (selectedPayload == null) return;

    try {
      await navigator.clipboard.writeText(JSON.stringify(selectedPayload, null, 2));
      store.addNotification({
        title: "Sucesso!",
        message: "JSON copiado com sucesso.",
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 3000, onScreen: true },
      });
    } catch (_) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(_, "ERRO-660 Não foi possível copiar o JSON - Tente novamente, se o erro persistir acione o suporte."),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
    }
  };

  const complementarColumns = [
    {
      label: "Nº Primeira Receita",
      minWidth: "140px",
      render: (row) => (
        <TaglineP color={theme.colors.gray.Cinza_1}>
          {row.agro_prescriptions_complementar?.[0]?.num_receita != null ? String(row.agro_prescriptions_complementar?.[0]?.num_receita) : "-"}
        </TaglineP>
      ),
    },
    {
      label: "Nº Receita Complementar",
      minWidth: "190px",
      render: (row) => (
        <TaglineP color={theme.colors.gray.Cinza_1}>
          {row.numero != null ? String(row.numero) : "-"}
        </TaglineP>
      ),
    },
    {
      label: "Agrônomo/Técnico",
      width: "100%",
      minWidth: "180px",
      render: (row) => (
        <TaglineP color={theme.colors.gray.Cinza_1}>
          {row.agronomo_nome || row.agronomo_crea || "-"}
        </TaglineP>
      ),
    },
    {
      label: "ART",
      minWidth: "120px",
      render: (row) => (
        <TaglineP color={theme.colors.gray.Cinza_1}>
          {row.numero_art || "-"}
        </TaglineP>
      ),
    },
    {
      label: "Data de Emissão",
      minWidth: "120px",
      render: (row) => (
        <TaglineP color={theme.colors.gray.Cinza_1}>
          {formatDate(row.data_emissao)}
        </TaglineP>
      ),
    },
    {
      label: "Produtor",
      minWidth: "150px",
      render: (row) => (
        <TaglineP color={theme.colors.gray.Cinza_1}>
          {row.produtor_nome || "-"}
        </TaglineP>
      ),
    },
    {
      label: "Propriedade",
      minWidth: "150px",
      render: (row) => (
        <TaglineP color={theme.colors.gray.Cinza_1}>
          {row.local_aplicacao_nome || "-"}
        </TaglineP>
      ),
    },
    {
      label: "Produto",
      minWidth: "180px",
      render: (row) => {
        const relations = row.agro_prescriptions_relations || [];
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            {relations.length > 0 ? (
              relations.map((rel, idx) => (
                <TaglineP key={idx} color={theme.colors.gray.Cinza_1}>
                  {rel.nome_comercial || "-"}
                </TaglineP>
              ))
            ) : (
              <TaglineP color={theme.colors.gray.Cinza_1}>-</TaglineP>
            )}
          </div>
        );
      },
    },
    {
      label: "Cultura/Problema",
      minWidth: "160px",
      render: (row) => (
        <TaglineP color={theme.colors.gray.Cinza_1}>
          {row.cultura_nome_comum || row.cultura_nome_cientifico || "-"}
        </TaglineP>
      ),
    },
    {
      label: "Alvo",
      minWidth: "180px",
      render: (row) => {
        const relations = row.agro_prescriptions_relations || [];
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            {relations.length > 0 ? (
              relations.map((rel, idx) => (
                <TaglineP key={idx} color={theme.colors.gray.Cinza_1}>
                  {rel.praga_nome_comum || rel.praga_nome_cientifico || "-"}
                </TaglineP>
              ))
            ) : (
              <TaglineP color={theme.colors.gray.Cinza_1}>-</TaglineP>
            )}
          </div>
        );
      },
    },
    {
      label: "Tipo de Aplicação",
      width: "100%",
      minWidth: "160px",
      render: (row) => {
        const relations = row.agro_prescriptions_relations || [];
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            {relations.length > 0 ? (
              relations.map((rel, idx) => (
                <TaglineP key={idx} color={theme.colors.gray.Cinza_1}>
                  {rel.modalidade_aplicacao || "-"}
                </TaglineP>
              ))
            ) : (
              <TaglineP color={theme.colors.gray.Cinza_1}>-</TaglineP>
            )}
          </div>
        );
      },
    },
    {
      label: "Qtd ou Área tratada",
      minWidth: "140px",
      render: (row) => {
        const relations = row.agro_prescriptions_relations || [];
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            {relations.length > 0 ? (
              relations.map((rel, idx) => (
                <TaglineP key={idx} color={theme.colors.gray.Cinza_1}>
                  {rel.area_tratar != null && rel.area_tratar !== "" ? String(rel.area_tratar) : "-"}
                </TaglineP>
              ))
            ) : (
              <TaglineP color={theme.colors.gray.Cinza_1}>-</TaglineP>
            )}
          </div>
        );
      },
    },
    {
      label: "Unidade de Medida",
      minWidth: "140px",
      render: (row) => {
        const relations = row.agro_prescriptions_relations || [];
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            {relations.length > 0 ? (
              relations.map((rel, idx) => (
                <TaglineP key={idx} color={theme.colors.gray.Cinza_1}>
                  {rel.unidade_area_tratar || "-"}
                </TaglineP>
              ))
            ) : (
              <TaglineP color={theme.colors.gray.Cinza_1}>-</TaglineP>
            )}
          </div>
        );
      },
    },
    {
      label: "Volume Utilizado",
      minWidth: "130px",
      render: (row) => {
        const relations = row.agro_prescriptions_relations || [];
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            {relations.length > 0 ? (
              relations.map((rel, idx) => {
                const qtd = rel.quantidade_adquirir;
                const un = rel.unidade_quantidade_adquirir;
                const text =
                  qtd != null && qtd !== ""
                    ? un
                      ? `${qtd} ${un}`
                      : qtd
                    : "-";
                return (
                  <TaglineP key={idx} color={theme.colors.gray.Cinza_1}>
                    {text}
                  </TaglineP>
                );
              })
            ) : (
              <TaglineP color={theme.colors.gray.Cinza_1}>-</TaglineP>
            )}
          </div>
        );
      },
    },
  ];

  const defaultColumns = [
  {
    label: "Status / Ação",
    key: "status",
    width: ufHomolog === "MT" ? "300px" : "220px",
    minWidth: "130px",
    enableHorizontalScroll: true,
    justifyContent: "flex-start",
    filterType: "checkbox",
    filterPanelWidth: ufHomolog === "MT" ? "335px" : undefined,
    filterOptions: statusFilterOptions,
    filterBy: (row) => getStatusLabelForFilter(row, ufHomolog),
    render: (row) => (
      <HomologButtonHistory
        style={{ width: "auto"}}
        estado={ufHomolog}
        receitaId={row.id}
        statusEnvio={parseInt(row.status_homologacao)}
        updateReceitas={fetchReceitas}
        propsLocation={props}
        homologado={row.homologado}
        homologacaoErro={row.homologacao_erro}
        dataReceita={row}
      />
    ),
  },
    {
      label: "Nº Receita",
      key: "numero",
      minWidth:  ufHomolog === "MT" ? "170px" : "120px",
      filterBy: (row) => (row.numero != null ? String(row.numero) : ""),
      render: (row) => (
        <TaglineP color={theme.colors.gray.Cinza_1}>
          {row.numero != null ? String(row.numero) : "-"}
        </TaglineP>
      ),
    },
    {
      label: "Nº Protocolo",
      key: "protocolo",
      minWidth:  ufHomolog === "MT" ? "170px" : "120px",
      filterBy: (row) => row.nu_receita || "",
      render: (row) => (
        <TaglineP color={theme.colors.gray.Cinza_1}>
          {row.nu_receita || "-"}
        </TaglineP>
      ),
    },
    {
      label: "Produtor",
      key: "produtor",
      width: "100%",
      minWidth: ufHomolog === "MT" ? "320px" : "280px",
      maxWidth: ufHomolog === "MT" ? "320px" : "280px",
      enableHorizontalScroll: true,
      filterBy: (row) => row.produtor_nome || "",
      render: (row) => (
        <TaglineP color={theme.colors.gray.Cinza_1}>
          {row.produtor_nome || "-"}
        </TaglineP>
      ),
    },
    {
      label: "Propriedade",
      key: "propriedade",
      width: "100%",
      minWidth: "220px",
      maxWidth: "220px",
      enableHorizontalScroll: true,
      filterBy: (row) => row.local_aplicacao_nome || "",
      render: (row) => (
        <TaglineP color={theme.colors.gray.Cinza_1}>
          {row.local_aplicacao_nome || "-"}
        </TaglineP>
      ),
    },
    {
      label: "Data Emissão",
      key: "data_emissao",
      minWidth: "140px",
      enableFilter: false,
      render: (row) => (
        <TaglineP color={theme.colors.gray.Cinza_1}>
          {formatDate(row.data_emissao)}
        </TaglineP>
      ),
    },
    {
      label: "Cultura",
      key: "cultura",
      width: "100%",
      minWidth: "120px",
      maxWidth: "130px",
      enableHorizontalScroll: true,
      filterBy: (row) => row.cultura_nome_comum || "",
      render: (row) => (
        <TaglineP color={theme.colors.gray.Cinza_1}>
          {row.cultura_nome_comum || "-"}
        </TaglineP>
      ),
    },
    {
      label: "Produtos",
      key: "produtos",
      width: "100%",
      minWidth: "200px",
      maxWidth: "220px",
      enableHorizontalScroll: true,
      filterBy: (row) => {
        const relations = row.agro_prescriptions_relations || [];
        return relations.map((rel) => rel?.nome_comercial || "").filter(Boolean).join(" | ");
      },
      render: (row) => {
        const relations = row.agro_prescriptions_relations || [];
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            {relations.length > 0 ? (
              relations.map((rel, idx) => (
                <TaglineP key={idx} color={theme.colors.gray.Cinza_1}>
                  {rel.nome_comercial || "-"}
                </TaglineP>
              ))
            ) : (
              <TaglineP color={theme.colors.gray.Cinza_1}>-</TaglineP>
            )}
          </div>
        );
      },
    },
    
    {
      label: "Número NF",
      key: "numero_nf",
      width: "100%",
      minWidth: "120px",
      maxWidth: "120px",
      enableHorizontalScroll: true,
      render: (row) => (
        <TaglineP color={theme.colors.gray.Cinza_1}>
          {getInvoiceNumberLabel(row)}
        </TaglineP>
      ),
    },
    ...(shouldShowPayloadColumn
      ? [
          {
            label: "DADOS DE ENVIO",
            key: "dados_envio",
            minWidth: "150px",
            enableFilter: false,
            render: (row) => {
              const hasPayload = !!getRequestPayloadFromRow(row);
              if (!hasPayload) {
                return <TaglineP color={theme.colors.gray.Cinza_1}>-</TaglineP>;
              }

              return (
                <S.ViewPayloadButton type="button" onClick={() => handleOpenPayloadModal(row)}>
                  VER JSON
                </S.ViewPayloadButton>
              );
            },
          },
        ]
      : []),
  ];

  const columns = uf === "COMPLEMENTAR" ? complementarColumns : defaultColumns;

  const guidanceByUf = {
    GO: {
      label: "Acesso ao SIDAGO (Agrodefesa/GO)",
      url: "https://goias.gov.br/agrodefesa/acesso-ao-sidago/",
    },
    DF: {
      label: "Acesso ao SIAGRO DF (SEAGRI/DF)",
      url: "https://siagro.seagri.df.gov.br/",
    },
    ES: {
      label: "Envio de receitas no e-Idaf (IDAF/ES)",
      url: "https://idaf.es.gov.br/faq-e-idaf",
    },
    MT: {
      label: "Manual oficial do SISDEV (INDEA/MT)",
      url: "https://sistemas.indea.mt.gov.br/SISDEV/archives/Manual_SISDEV_prod.pdf",
    },
    SC: {
      label: "Acessar SIGEN+ (CIDASC/SC)",
      url: "https://sigen.cidasc.sc.gov.br/Account/LogOn?ReturnUrl=%2F",
    },
  };

  const guidanceKey = uf === "COMPLEMENTAR" ? "MT" : uf;
  const guidance = guidanceByUf[guidanceKey];

  return (
    <>
      <GenericUpper
        title={
          uf === "COMPLEMENTAR"
            ? "Exportar Defesas - MT (Receita complementar)"
            : `Exportar Defesas - ${uf}`
        }
        backLink="/exportar-defesas"
      />
      <Container style={{ paddingLeft: "32px", paddingRight: "32px" }}>
        <div style={{ maxWidth: '820px', margin: '16px auto 8px', textAlign: 'center' }}>
          <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={800}>
            Baixe relatórios referente à emissão de receituários para enviar às Defesas Agropecuárias, conforme regras de cada UF, cumprindo com as obrigações legais para fiscalização.
          </TaglineP>
          {guidance && (
            <p style={{ fontSize: '14px', marginTop: '8px' }}>
              Precisa de orientação?{' '}
              <a href={guidance.url} target="_blank" rel="noreferrer noopener">{guidance.label}</a>.
            </p>
          )}
        </div>
        <Row style={{ alignItems: "flex-start", justifyContent: "center", marginTop: "20px", marginBottom: "20px" }}>
          <Col md={3} style={{ marginBottom: "16px" }}>
            <Input
              id="dataInicio"
              type="date"
              name="dataInicio"
              label="Data Início"
              value={dataInicio}
              onChange={(value) => setDataInicio(value)}
              required={false}
              height="fit-content"
              marginBottom="0"
            />
          </Col>
          <Col md={3} style={{ marginBottom: "16px" }}>
            <Input
              id="dataFim"
              type="date"
              name="dataFim"
              label="Data Fim"
              value={dataFim}
              onChange={(value) => setDataFim(value)}
              required={false}
              height="fit-content"
              marginBottom="0"
            />
          </Col>
          <Col
            md={3}
            style={{
              display: "flex",
              alignItems: "flex-end",
              marginBottom: "16px",
            }}
          >
            <Button
              id="filtrar"
              name="filtrar"
              value="Filtrar"
              width="100%"
              height="40px"
              onClick={() => resetPaginacaoEBuscar()}
            />
          </Col>
          {["GO", "DF", "ES", "MT", "SC", "COMPLEMENTAR"].includes(uf) && (
            <Col
              md={3}
              style={{
                display: "flex",
                alignItems: "flex-end",
                marginBottom: "16px",
              }}
            >
              <Button
                id="exportar"
                name="exportar"
                value="EXPORTAR"
                width="100%"
                height="40px"
                outline={!exporting}
                color="#000"
                loaderColor="#fff"
                loading={exporting}
                onClick={() => handleExportarArquivo()}
              />
            </Col>
          )}
        </Row>
        {loading && receitas.length === 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "50px",
            }}
          >
            <Loading size="64px" />
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              paddingBottom: "40px",
            }}
          >
            <div style={{ position: "relative", minHeight: visibleRowsCount === 0 ? "170px" : "auto" }}>
              <TableWithLabelBlackV2
                columns={columns}
                data={receitas}
                showAll={true}
                itemsPerPage={limit}
                serverSide={true}
                enableColumnFilters={uf !== "COMPLEMENTAR"}
                useServerSideColumnFilters={uf !== "COMPLEMENTAR"}
                isLoading={tableLoading}
                emptyMessage="Não há resultados"
                onColumnFiltersChange={handleColumnFiltersChange}
                onCountChange={(_, visibleCount) => setVisibleRowsCount(visibleCount)}
              />
            </div>
            {total > 0 && (
              <PaginatorV2
                perPage={limit}
                total={total}
                currentPage={limit > 0 ? Math.floor(offset / limit) + 1 : 1}
                totalItens={receitas.length}
                onChange={handlePaginatorChange}
              />
            )}
          </div>
        )}
      </Container>

      {showPayloadModal && (
        <Modal
          show={showPayloadModal}
          onHide={() => setShowPayloadModal(false)}
          width="900px"
          responsive
        >
          <H5 color={theme.colors.gray.Cinza_2} fontWeight={700}>
            JSON da requisição
          </H5>

          <S.PayloadFrame>
            <S.PayloadCopyRow onClick={copyPayloadJson}>
              <img src={iconCopy} alt="Copiar código" />
            </S.PayloadCopyRow>

            <S.PayloadPre>
              {selectedPayload != null
                ? JSON.stringify(selectedPayload, null, 2)
                : "Sem dados de envio para esta receita."}
            </S.PayloadPre>
          </S.PayloadFrame>
        </Modal>
      )}
    </>
  );
};

export default withRouter(ExportarDefesasDetails);
